export default __webpack_public_path__ + "static/media/loginImage.003a5da1.png";